<template>
  <div class="notice mt-20">
    <block-head title="项目聚焦" subtitle="/ 精准匹配，优质直达" :more-btn-url="moreBtnUrl" />
    <ul class="notice-link-list">
      <li v-for="item in dataList" :key="item.id" class="item">
        <Link :to="item.url" class="img-link" target="_blank" :title="item.title">
          <img :alt="item.title" :src="item.adImage||require('@/assets/images/home/default.jpg')" @error="handleImageError($event)">
          <div class="txt flex-center">
            <p class="el-2" :title="item.title">{{ item.title }}</p>
          </div>
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import BlockHead from "@/views/home/components/BlockHead.vue";
import adApi from "@/api/ad";
import { AD_CODE } from "@/utils/constant";
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";

export default {
  name: "RecommendKey",
  components: { Link, BlockHead },
  props: {
  },
  data() {
    return {
      dataList: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    moreBtnUrl() {
      return "/ad/list/" + AD_CODE.AD_IMPORTANT;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.loadListData()
  },
  // 方法集合
  methods: {
    handleImageError(event) {
      console.log("图片加载失败，使用默认图片");
      event.target.src = require("@/assets/images/home/default.jpg"); // 替换为本地图片路径
    },
    loadListData() {
      adApi.page({ pageNo: 1, pageSize: 4, type: AD_CODE.AD_IMPORTANT }).then((res) => {
        this.dataList = res.data.list;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.notice {
  .notice-link-list{
    display: flex;
    flex-flow: row wrap;
	.item{
		margin-top: 15px;
    margin-right: 16px;
    width: 288px;
    height: 210px;
    background: #EEEEEE;
    position: relative;
		img{
			width: 100%;
			height: 210px;
      // object-fit: contain;
		}
		.txt{
			width: 100%;
			height: 50px;
      background: rgb(0,0,0,0.5);
			padding: 10px;
      position: absolute;
      bottom: 0;
			p{
				width: 100%;
				color: #FFF;
				font-size: 14px;
				line-height: 18px;
			}
		}

    &:nth-of-type(4n) {
        margin-right: 0;
      }
	}
}
}
</style>
